import {ApplicationRef, Injectable} from '@angular/core';
import {IdwMatrixListService} from './idw-matrix-list.service';
import {StateService} from '../../../core/services/state/state.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
// import {IMyOptions} from 'mydatepicker';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {ContentSearchFilters} from '../../../shared/classes/services/content_search_filters';

@Injectable({
    providedIn: 'root'
})
export class IdwMatrixSearchFiltersService extends ContentSearchFilters {

    public preferences: boolean;
    public filter: boolean;

    public datePickerOptions: any = {dateFormat: 'dd/mm/yyyy'};
    public dateStart: any;
    public dateEnd: any;
    public dateStartModel = {};
    public dateEndModel = {};
    public hiringDateModel = {};

    public testsOptions: any;
    public optionsTestsModel: any = [];

    public dropDownSettings: IDropdownSettings = {
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 1,
        enableCheckAll: false
    };

    public subAccountsOptions = [];
    public subAccountsOptionsModel: any = [];

    public departmentOptions = [];
    public departmentOptionsModel: any = [];

    public testStatuses: any = {};
    public optionsTestsStatusModel = [];
    public optionsTestsStatusRaModel = [];

    public testsStatusOptions: any;

    public checkedColumn: any = [];

    public sortCardsBy = '';
    public sortCardsOrder = 'asc';

    constructor(
        public stateService: StateService,
        protected router: Router,
        protected applicationRef: ApplicationRef,
        protected deviceService: DeviceDetectorService,
        protected idwMatricesList: IdwMatrixListService
    ) {
        super(stateService, router, applicationRef, deviceService);
    }

    initInputState() {
        if (this.idwMatricesList.idwMatrixState.listSearchFilters) {
            // Sub-accounts
            if (this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount) {
                let subAccArr = this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount;
                if (typeof this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }
                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }
            // Departments
            this.setDepartmentsModel(this.idwMatricesList.idwMatrixState);
        }

        let colSelected = 0;
        for (let col of this.columns) {
            if (this.filtering(this.listColumns, col)) {
                colSelected++;
            }
        }
        // this.columnsToSelect = this.maxNumberOfColumns - colSelected;
    }

    initInputStatePreferences(obj) {
        // override these with user preferences
        if (obj.userPreferences && obj.userPreferences.idwMatrix) {
            for (let col in obj.userPreferences.idwMatrix.display) {
                if (obj.userPreferences.idwMatrix.display.hasOwnProperty(col)) {
                    let index = 0;
                    for (let o of this.listColumns) {
                        if (o.key === obj.userPreferencesService.plusToDot(col)) {
                            if (this.listColumns[index]) {
                                this.listColumns[index].display = obj.userPreferences.idwMatrix.display[col];
                            }
                        } else {
                        }
                        index++;
                    }
                }
            }
        }
        if (this.idwMatricesList.idwMatrixState.listSearchFilters) {
            // Sub-accounts
            this.subAccountsOptionsModel = [];
            if (this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount) {
                let subAccArr = this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount;
                if (typeof this.idwMatricesList.idwMatrixState.listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }

                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }
            // Departments
            this.setDepartmentsModel(this.idwMatricesList.idwMatrixState);
            if (obj && obj.changeDetectorRef) {
                obj.changeDetectorRef.markForCheck();
            }
        }
    }

    get columns() {
        return this.idwMatricesList.columns;
    }

    get listColumns() {
        return this.idwMatricesList.listColumns;
    }
}
